import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { HashtagAction, SubItemsSharedAction } from "../actions";
import * as hashtagApi from "../api/hashtag";
import { toastr } from "react-redux-toastr";
import { goBack } from "connected-react-router";
import { SetMessage } from "../assets/errorMessages";
import {
  defaultNormalizerWithSeparateMetaObj,
  fetchAllPages
} from "../assets/fetchAllPageTogether";

export function* watcherHashtag() {
  yield takeLatest(types.GET_HASHTAG_REQUEST, get);
  yield takeLatest(types.SHOW_HASHTAG_REQUEST, show);
  yield takeLatest(types.REMOVE_HASHTAG_REQUEST, remove);
  yield takeLatest(types.STORE_HASHTAG_REQUEST, store);
  yield takeLatest(types.UPDATE_HASHTAG_REQUEST, update);
}

function* get() {
  try {
    const response = yield fetchAllPages(
      getRequest,
      null,
      defaultNormalizerWithSeparateMetaObj,
      null,
      true
    );
    yield put(HashtagAction.getListSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(HashtagAction.getListFailure(message));
  }
}
function getRequest(pageNumber = null) {
  return hashtagApi.getList(pageNumber);
}

function* show(action) {
  try {
    const response = yield call(showRequest, action.id);
    yield put(HashtagAction.showSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(HashtagAction.showFailure(message));
  }
}
function showRequest(id) {
  return hashtagApi.show(id);
}

function* remove(action) {
  try {
    const response = yield call(removeRequest, action.id);
    response.data.message.forEach(message => {
      toastr.error(" ", message.toString());
    });
    yield put(HashtagAction.removeSuccess(action.id));
    if (action.goBack) {
      yield put(goBack());
    }
  } catch (error) {
    SetMessage(error, true);
    yield put(HashtagAction.removeFailure());
  }
}
function removeRequest(id) {
  return hashtagApi.remove(id);
}

function* store(action) {
  try {
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: true }));
    const response = yield call(storeRequest, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(SubItemsSharedAction.closeAddModal());
    yield put(HashtagAction.storeSuccess(response.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: false }));
    yield put(HashtagAction.storeFailure());
  }
}
function storeRequest(data) {
  return hashtagApi.store(data);
}

function* update(action) {
  try {
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: true }));
    const response = yield call(updateRequest, action.id, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(SubItemsSharedAction.closeAddModal());
    yield put(HashtagAction.updateSuccess(response.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: false }));
    yield put(HashtagAction.updateFailure());
  }
}
function updateRequest(id, data) {
  return hashtagApi.update(id, data);
}
